// Add utility function
const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

export default capitalizeFirstLetter;
  
  // Example usage in your message:
//   const message = `This account was registered using ${capitalizeFirstLetter(result.originalRegisterMethod)}.  If you sign in with Google now, you must continue to use Google as your sign in method.  Email and password sign in will no longer work for this account.`;